"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.drilldownActive = void 0;
var re_reselect_1 = __importDefault(require("re-reselect"));
var viewmodel_1 = require("../../layout/viewmodel/viewmodel");
var partition_spec_1 = require("./partition_spec");
exports.drilldownActive = re_reselect_1.default([partition_spec_1.getPartitionSpecs], function (specs) {
    return specs.length === 1 && viewmodel_1.isSimpleLinear(specs[0].config, specs[0].layers);
})(function (state) { return state.chartId; });
//# sourceMappingURL=drilldown_active.js.map